// extracted by mini-css-extract-plugin
module.exports = {"faqContent":"page_faqContent__IxYxH","faqMenuCard":"page_faqMenuCard__NIq0V","vrmLookupSectionDesktop":"page_vrmLookupSectionDesktop__736Jx"};